// extracted by mini-css-extract-plugin
export default {"section":"Section-module__section__F6c2mJO","withBorder":"Section-module__withBorder__x5FcdAG","intro":"Section-module__intro__XBJ1NEW"};